import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppScope } from '@klickdata/core/resource';

@Component({
    selector: 'app-main-catalog-surveys',
    templateUrl: './main-catalog-surveys.component.html',
    styleUrls: ['./main-catalog-surveys.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainCatalogSurveysComponent implements OnInit {
    AppScope = AppScope;
    constructor() {}

    ngOnInit(): void {}
}
